import PropTypes from 'prop-types'

// These are the props that are passed to the specific TaskComponent (see ListSubmissionsForTaskIndex component)
export const FormComponentPropTypes = {
  onUpdateSubmission: PropTypes.func.isRequired,
  onRemoveSubmission: PropTypes.func.isRequired,
  submission: PropTypes.object.isRequired,
  task: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
}
